/* tuinbeeldenkopen.nl — global.js */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  /* ---------- Drawers (mobiel menu + filters) ---------- */
  function open(drawer, scrim) { if (!drawer) return; drawer._returnFocus=document.activeElement; drawer.classList.add('open'); drawer.setAttribute('aria-hidden','false'); if (scrim) scrim.classList.add('open'); document.body.style.overflow = 'hidden'; var closeBtn=drawer.querySelector('[data-close-menu],[data-close-filters]'); if(closeBtn) closeBtn.focus(); }
  function close(drawer, scrim) { if (!drawer) return; drawer.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); if (scrim) scrim.classList.remove('open'); document.body.style.overflow = ''; if(drawer._returnFocus && document.contains(drawer._returnFocus)) drawer._returnFocus.focus(); drawer._returnFocus=null; }

  var menu = document.getElementById('menu-drawer');
  var menuScrim = document.getElementById('menu-scrim');
  var filters = document.getElementById('filter-drawer');
  var filterScrim = document.getElementById('filter-scrim');

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-open-menu]')) { open(menu, menuScrim); }
    if (e.target.closest('[data-close-menu]')) { close(menu, menuScrim); }
    if (e.target.closest('[data-open-filters]')) { e.preventDefault(); open(filters, filterScrim); }
    if (e.target.closest('[data-close-filters]')) { close(filters, filterScrim); }

    var subBtn = e.target.closest('[data-submenu]');
    if (subBtn) {
      var li = subBtn.closest('.m-item');
      if (li) li.classList.toggle('expanded');
    }

    var thumb = e.target.closest('[data-img]');
    if (thumb) {
      var main = document.getElementById('pdp-main-img');
      if (main) { main.src = thumb.getAttribute('data-img'); }
      var group = thumb.closest('.pdp-thumbs');
      if (group) { group.querySelectorAll('button').forEach(function (b) { b.classList.remove('active'); }); }
      thumb.classList.add('active');
    }

    var qb = e.target.closest('[data-qty]');
    if (qb) {
      var wrap = qb.closest('.qty');
      var input = wrap ? wrap.querySelector('input') : null;
      if (input) {
        var v = parseInt(input.value, 10) || 1;
        v = qb.getAttribute('data-qty') === 'plus' ? v + 1 : Math.max(1, v - 1);
        input.value = v;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { close(menu, menuScrim); close(filters, filterScrim); }
  });

  /* ---------- Scroll-reveal ---------- */
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
  }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
  document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });

  /* ---------- Hero slider ---------- */
  function initHero(root) {
    var track = root.querySelector('.slides');
    if (!track || track.children.length < 2) return;
    var total = track.children.length;
    var dots = Array.prototype.slice.call(root.querySelectorAll('.hero-dots button'));
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var i = 0, timer = null;
    function go(n) {
      i = (n + total) % total;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      dots.forEach(function (d, x) { d.classList.toggle('active', x === i); });
    }
    function start() { if (autoplay && !reduce) timer = setInterval(function () { go(i + 1); }, 6000); }
    function restart() { clearInterval(timer); start(); }
    var next = root.querySelector('.hero-arrow.next'), prev = root.querySelector('.hero-arrow.prev');
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    dots.forEach(function (d, x) { d.addEventListener('click', function () { go(x); restart(); }); });
    var sx = null;
    track.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); restart(); }
      sx = null;
    }, { passive: true });
    start();
  }
  document.querySelectorAll('.hero-slider').forEach(initHero);

  /* ---------- Filters: automatisch toepassen bij wijziging ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input, select')) { form.submit(); }
    });
  });

  /* ---------- Sticky mobiele koopbalk ---------- */
  var anchor = document.getElementById('pdp-atc');
  var sticky = document.getElementById('sticky-atc');
  if (anchor && sticky) {
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { sticky.classList.toggle('show', !en.isIntersecting && en.boundingClientRect.top < 0); });
    }, { threshold: 0 });
    so.observe(anchor);
  }

  /* ---------- Winkelwagen-drawer ---------- */
  (function initCart(){
    var drawer = document.getElementById('cart-drawer');
    var scrim = document.getElementById('cart-scrim');
    if (!drawer) return;
    var itemsEl = drawer.querySelector('[data-cart-items]');
    var emptyEl = drawer.querySelector('[data-cart-empty]');
    var footEl = drawer.querySelector('[data-cart-foot]');
    var subEl = drawer.querySelector('[data-cart-subtotal]');
    var shipEl = drawer.querySelector('[data-ship]');
    var shipMsg = drawer.querySelector('[data-ship-msg]');
    var shipFill = drawer.querySelector('[data-ship-fill]');
    var upsellEl = drawer.querySelector('[data-upsell]');
    var upsellRow = drawer.querySelector('[data-upsell-row]');
    var headCountEl = drawer.querySelector('[data-cart-head-count]');
    var threshold = parseInt(drawer.getAttribute('data-free-threshold'), 10) || 0;
    var returnFocus = null;

    function money(c){ return '€ ' + (c/100).toFixed(2).replace('.', ','); }
    function px(u){ return u ? u.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, '_160x$1$2') : ''; }
    function esc(v){ return String(v == null ? '' : v).replace(/[&<>"']/g,function(ch){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[ch]; }); }
    function openCart(){ returnFocus=document.activeElement; drawer.classList.add('open'); if(scrim) scrim.classList.add('open'); drawer.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; var closeBtn=drawer.querySelector('[data-close-cart]'); if(closeBtn) closeBtn.focus(); }
    function closeCart(){ drawer.classList.remove('open'); if(scrim) scrim.classList.remove('open'); drawer.setAttribute('aria-hidden','true'); document.body.style.overflow=''; if(returnFocus && document.contains(returnFocus)) returnFocus.focus(); returnFocus=null; }
    function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; }); if(headCountEl) headCountEl.textContent=n; }

    function lineRow(item, idx){
      var props='';
      if(item.properties){ for(var k in item.properties){ if(k.charAt(0)!=='_' && item.properties[k]) props += '<span class="cd-prop">'+esc(k)+': '+esc(item.properties[k])+'</span>'; } }
      return '<div class="cd-item" data-line="'+(idx+1)+'">'
        + (item.image?'<a href="'+esc(item.url)+'" class="cd-thumb"><img src="'+esc(px(item.image))+'" alt="" loading="lazy" width="74" height="74"></a>':'<span class="cd-thumb"></span>')
        + '<div class="cd-info">'
        +   '<a href="'+esc(item.url)+'" class="cd-title">'+esc(item.product_title)+'</a>'
        +   ((item.variant_title && item.variant_title!=='Default Title')?'<span class="cd-variant">'+esc(item.variant_title)+'</span>':'')
        +   props
        +   '<div class="cd-line-bottom">'
        +     '<div class="cd-qty"><button data-cq="down" aria-label="Minder">−</button><span>'+item.quantity+'</span><button data-cq="up" aria-label="Meer">+</button></div>'
        +     '<span class="cd-price">'+money(item.final_line_price)+'</span>'
        +   '</div>'
        +   '<button class="cd-remove" data-cq="remove">Verwijderen</button>'
        + '</div></div>';
    }
    function renderShip(total){
      if(!threshold){ shipEl.hidden=true; return; }
      shipEl.hidden=false;
      if(total>=threshold){ shipMsg.innerHTML='Gelukt — je hebt <b>gratis verzending in Nederland</b>!'; shipFill.style.width='100%'; }
      else { shipMsg.innerHTML='Nog <b>'+money(threshold-total)+'</b> tot gratis verzending in Nederland'; shipFill.style.width=Math.min(100,(total/threshold)*100)+'%'; }
    }
    function loadUpsell(cart){
      if(!cart.items.length){ upsellEl.hidden=true; return; }
      fetch('/recommendations/products.json?product_id='+cart.items[0].product_id+'&limit=4&intent=complementary')
        .then(function(r){return r.json();})
        .then(function(d){
          var inCart = cart.items.map(function(i){return i.product_id;});
          var recs=(d.products||[]).filter(function(p){return inCart.indexOf(p.id)===-1 && p.available;}).slice(0,3);
          if(!recs.length){ upsellEl.hidden=true; return; }
          upsellRow.innerHTML = recs.map(function(p){
            var vid=(p.variants&&p.variants[0])?p.variants[0].id:'';
            return '<div class="cd-up"><a href="'+esc(p.url)+'" class="cd-up-link">'+(p.featured_image?'<img src="'+esc(px(p.featured_image))+'" alt="" loading="lazy" width="46" height="46">':'<span class="cd-up-noimg"></span>')+'<span class="cd-up-t">'+esc(p.title)+'</span></a>'
              +'<span class="cd-up-b"><span class="cd-up-p">'+money(p.price)+'</span><button class="cd-up-add" data-add-id="'+esc(vid)+'" aria-label="Voeg '+esc(p.title)+' toe aan winkelwagen">+</button></span></div>';
          }).join('');
          upsellEl.hidden=false;
        }).catch(function(){ upsellEl.hidden=true; });
    }
    function render(cart){
      setCount(cart.item_count);
      if(!cart.item_count){ itemsEl.innerHTML=''; emptyEl.hidden=false; footEl.hidden=true; shipEl.hidden=true; upsellEl.hidden=true; return; }
      emptyEl.hidden=true; footEl.hidden=false;
      itemsEl.innerHTML = cart.items.map(lineRow).join('');
      subEl.textContent = money(cart.total_price);
      renderShip(cart.total_price);
      loadUpsell(cart);
    }
    function get(){ return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}); }
    function refresh(){ return get().then(render); }
    function change(line, qty){ return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(function(r){return r.json();}).then(render); }
    function addFD(fd){ return fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:fd}).then(function(r){ if(!r.ok) return r.json().then(function(e){throw e;}); return r.json(); }); }

    document.addEventListener('submit', function(e){
      var form = e.target.closest('#product-form, .card-add-form');
      if(!form) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if(btn){ btn.classList.add('loading'); btn.disabled=true; }
      addFD(new FormData(form)).then(refresh).then(openCart).catch(function(){ form.submit(); }).finally(function(){ if(btn){ btn.classList.remove('loading'); btn.disabled=false; } });
    });
    drawer.addEventListener('click', function(e){
      var cq = e.target.closest('[data-cq]');
      var row = e.target.closest('.cd-item');
      if(cq && row){
        var line = parseInt(row.getAttribute('data-line'),10);
        var cur = parseInt(row.querySelector('.cd-qty span').textContent,10)||1;
        var a = cq.getAttribute('data-cq');
        if(a==='up') change(line, cur+1); else if(a==='down') change(line, Math.max(0,cur-1)); else change(line, 0);
        return;
      }
      var add = e.target.closest('[data-add-id]');
      if(add){ var fd=new FormData(); fd.append('id', add.getAttribute('data-add-id')); fd.append('quantity','1'); add.disabled=true; addFD(fd).then(refresh).catch(function(){}).finally(function(){ add.disabled=false; }); }
    });
    document.addEventListener('click', function(e){
      if(e.target.closest('[data-open-cart]')){ e.preventDefault(); refresh().then(openCart); }
      if(e.target.closest('[data-close-cart]')){ closeCart(); }
    });
    document.addEventListener('keydown', function(e){
      if(e.key==='Escape') closeCart();
      if(e.key==='Tab' && drawer.classList.contains('open')){
        var focusable=[].slice.call(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'));
        if(!focusable.length) return;
        var first=focusable[0], last=focusable[focusable.length-1];
        if(e.shiftKey && document.activeElement===first){ e.preventDefault(); last.focus(); }
        else if(!e.shiftKey && document.activeElement===last){ e.preventDefault(); first.focus(); }
      }
    });
    get().then(function(c){ setCount(c.item_count); }).catch(function(){});
  })();

  /* ---------- Nieuwsbrief: confetti bij succes ---------- */
  (function initNews(){
    var ok = document.querySelector('.news-success');
    if(!ok || reduce) return;
    var colors=['#E08A3C','#2E8560','#1C5540','#A99878','#8FC6A8'];
    for(var i=0;i<14;i++){
      var s=document.createElement('span'); s.className='confetti';
      s.style.left=(10+Math.random()*80)+'%'; s.style.background=colors[i%colors.length];
      s.style.animationDelay=(Math.random()*0.3)+'s'; s.style.transform='rotate('+(Math.random()*360)+'deg)';
      ok.appendChild(s);
    }
  })();
})();

